<template>
  <YuliStaking />
</template>

<script>
import YuliStaking from "@/components/YuliStaking";
export default {
  components: {
    YuliStaking,
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped></style>
